import { IconButton, Tooltip } from "@carbon6/c6-frontend-design";
import type { MappingEditorState } from "../../feature/mappingEditor";
import type { InspectSidePanel } from "../../feature/inspectSession";
import { sameMapping } from "../../feature/mappingEdit";
import { validationSummary } from "../../feature/mappingReview";
import styles from "./InspectPipeline.module.css";

export function InspectPipeline({
  state,
  probeUuid,
  selected,
  onSelect,
}: {
  state: MappingEditorState;
  probeUuid: string;
  selected: InspectSidePanel;
  onSelect: (step: InspectSidePanel) => void;
}) {
  const poc = state.poc;
  const pocStatus =
    poc.status === "tracking"
      ? !sameMapping(poc.sent, state.draft) || poc.job.probeUuid !== probeUuid
        ? "이전 입력 결과"
        : { queued: "대기", running: "실행 중", succeeded: "성공", failed: "실패" }[poc.job.state]
      : { idle: "요청 전", requesting: "접수 중", failed: "접수 실패" }[poc.status];
  const steps: readonly { id: InspectSidePanel; label: string; status: string }[] = [
    {
      id: "mcp",
      label: "MCP 연결 확인",
      status: "클라이언트에서 mcp_usage_guide를 호출해 연결을 확인하세요.",
    },
    {
      id: "mapping",
      label: "사람 검토",
      status: "영상과 핸드의 방향을 비교하세요.",
    },
    { id: "validation", label: "샘플 검증", status: validationSummary(state, probeUuid) },
    { id: "poc", label: "POC", status: pocStatus },
  ];
  return (
    <nav aria-label="점검·매핑 진행 단계">
      <ol className={styles.steps}>
        {steps.map((step, index) => {
          const current = (selected === "channels" ? "mapping" : selected) === step.id;
          return (
            <li key={step.id}>
              <Tooltip content={step.status} describeTrigger>
                <IconButton
                  text={`${index + 1} ${step.label}`}
                  aria-label={step.label}
                  aria-current={current ? "step" : undefined}
                  variant={current ? "solid" : "surface"}
                  border
                  size="sm"
                  onClick={() => onSelect(step.id)}
                />
              </Tooltip>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
